import { toast } from '@systemeio/ui'
import { MailingId } from 'modules/mailing/types/mailing-interface'
import { MailingSettingsInterface } from 'modules/profile/mailing-settings/types/mailing-settings-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

export const useSendTestEmail = () => {
  const { t } = useLocoTranslation()

  const { fetcher } = useFetch({
    method: RequestMethodsEnum.post,
  })

  return {
    fetcherSendTestEmail: async (
      mailingId: MailingId,
      data: { email: MailingSettingsInterface['testEmailAddress'] },
    ) => {
      try {
        await fetcher(`/api/dashboard/customer/mailing/${mailingId}/send-test`, data)
        toast.success(
          t('dashboard.newsletter_editor.send_test_successful_message', { email: data.email }),
        )
      } catch (e) {
        throw e
      }
    },
  }
}
